// Custom breakpoints

const xs = 375;

export const xsUp = `@media (min-width: ${xs}px)`;
